import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { getTableByIdBd, insertTableBd, updateTableBd } from '../../config/functions'
import { toast } from 'react-toastify'

const ModalCampoPozo = ({ show, handleClose, rig, setCampos, deRporte, camposPozos, setCamposPozos }) => {

    const [camposPozosCompletos, setCamposPozosCompletos] = useState([])
    const [campo, setCampo] = useState('')
    const [pozo, setPozo] = useState('')
    const user = JSON.parse(localStorage.getItem("token")).userName;

    //-----------------------------------------------------

    const guardarNueva = async () => {
        if (!campo.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }

        const dataToSend = {
            rig: rig,
            campo: campo.toLocaleUpperCase(),
            pozo: pozo.toLocaleUpperCase(),
            usuario_modifico: user,
        };

        try {
            await insertTableBd('createCamposPozos', dataToSend, dataToSend);
            await cargarCampoPozos()
            toast.success(`guardado exitosamente.`);
            handleClose();
        } catch (error) {
            toast.error('Error al guardar los datos.');
        }
    }

    const cambioEstado = async (estado, id) => {

        const dataToSend = {
            id,
            activo: estado === 'S' ? 'N' : 'S',
            usuario_modifico: user,
        };
        try {
            const response = await updateTableBd('changecampospozos', dataToSend);
            if (response) {
                await cargarCampoPozos()
                toast.success(`cambio de estado exitosamente.`);
            }
        } catch (error) {
            toast.error('Error al guardar los datos.');
        }
    }

    const cargarCampoPozos = async () => {
        try {
            const data = await getTableByIdBd(rig, 'getCamposPozos')
            if (data && data.length >= 1) {

                const activos = data.filter(op => op.activo === 'S');
                setCamposPozos(activos);
                setCamposPozosCompletos(data);

                const camposTemp = activos
                    .map(op => ({ id: op.id, name: op.campo }))
                    .filter((item, index, self) =>
                        self.findIndex(i => i.name === item.name) === index
                    )
                    .sort((a, b) => a.name.localeCompare(b.name));
                setCampos(camposTemp)
            }
            else {
                setCamposPozos([]);
                if (deRporte) setCampos([])
            }
        } catch (error) {
            toast.warning('bd don\'t work')
        }
    }

    useEffect(() => {
        if (show && rig) {
            cargarCampoPozos()
            setPozo('')
            //setPozo(rig.pozo)
        }
    }, [show, rig])

    //------------------------------------------------------

    return (
        <Modal show={show} onHide={handleClose} id="alarmModal" aria-labelledby="alarmModalLabel" >

            <Modal.Header closeButton>
                <Modal.Title> Adicionar Campo - Pozo </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Table striped bordered hover size="sm" responsive="sm">
                    <thead>
                        <tr>
                            <th colSpan={4} className='text-center'>Campos - Pozos <br /> {rig.rig}</th>
                        </tr>
                        <tr>
                            <th>Campo</th>
                            <th>Pozo</th>
                            <th className='text-center'>Act</th>

                        </tr>
                    </thead>
                    <tbody>
                        {camposPozosCompletos.map((cp) => (
                            <tr key={cp.id}>
                                <td>{cp.campo}</td>
                                <td>{cp.pozo}</td>
                                <td className='text-center'
                                    onDoubleClick={() => cambioEstado(cp.activo, cp.id)}
                                    title='Doble click para cambiar estado'
                                    style={{ cursor: 'pointer' }}
                                    >
                                    <i className={`fa-solid ${cp.activo === 'S' ? 'fa-check' : 'fa-xmark'}`}
                                        style={{ color: cp.activo === 'S' ? 'green' : 'red' }}></i>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td>
                                <Form.Control
                                    type="text"
                                    aria-label="Campo"
                                    value={campo}
                                    onChange={(e) => setCampo(e.target.value)}
                                    placeholder="Campo"
                                    size="sm"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    aria-label="Pozo"
                                    value={pozo}
                                    onChange={(e) => setPozo(e.target.value)}
                                    placeholder="Pozo"
                                    size="sm"
                                />
                            </td>

                            <td>
                                <Button
                                    variant="primary"
                                    className='fa-solid fa-floppy-disk'
                                    onClick={guardarNueva}
                                />
                            </td>
                        </tr>
                    </tbody>
                </Table>

            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}> Close </Button>
            </Modal.Footer>
        </Modal >
    )
}

export default ModalCampoPozo